import { useCallback, useEffect, useRef, useState } from 'react'

/** Standaardduur van een korte bevestiging in de knop zelf. */
const FLASH_MS = 1400

/**
 * Kortstondige bevestiging, bijv. "Toegevoegd" in een knop.
 * Opnieuw afvuren verlengt de bevestiging; de timer wordt opgeruimd bij unmount.
 */
export function useFlash(ms = FLASH_MS): [boolean, () => void] {
  const [on, setOn] = useState(false)
  const timer = useRef<number | undefined>(undefined)

  useEffect(() => () => window.clearTimeout(timer.current), [])

  const trigger = useCallback(() => {
    window.clearTimeout(timer.current)
    setOn(true)
    timer.current = window.setTimeout(() => setOn(false), ms)
  }, [ms])

  return [on, trigger]
}
